import React from 'react';
import { Calendar } from 'antd';
import type { CalendarProps as AntCalendarProps } from 'antd';
import type { Dayjs } from 'dayjs';
import type { BaseComponentProps } from '../../types/common';

export interface AndCalendarProps extends AntCalendarProps<Dayjs>, BaseComponentProps {}

export const AndCalendar: React.FC<AndCalendarProps> = ({
  id, sessionId, develop, ...restProps
}) => {
  return <Calendar {...restProps} />;
};

export default AndCalendar;
